import { graphql } from "relay-runtime"

const deFavoriteAgentsByPatientQuery = graphql`
  query deFavoriteAgentsByPatientQuery($patientId: ID!) {
    patientById: de_patientById(id: $patientId) {
      favoriteAgentUserNames
    }
  }
`
export { deFavoriteAgentsByPatientQuery as de_FavoriteAgentsByPatientQuery }
